export default "__VITE_ASSET__ecaa1e7c__"